import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
export default function SplitLayoutWithImage() {
  return <section data-section-id="187371" id="imageandtextsplit" className="bg-background text-white py-16 overflow-hidden ![margin:-30px_0px_0px_0px] !h-[1000px] md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className="flex flex-col items-start max-w-2xl">
            <h1 className="font-bold font-default text-foreground leading-[1.1] tracking-tight !text-4xl ![margin:-90px_0px_0px_20px]">Revitalizing Startup Through <br />Major Deals &amp; Investment</h1>
            <p className="text-muted-foreground font-sans text-lg leading-relaxed ![margin:24px_0px_0px_20px] md:text-xl">
              "We've won two brand new deals with some significant organizations in our market which was game
              changing.
            </p>
            <p className="text-muted-foreground font-sans text-lg leading-relaxed ![margin:24px_0px_0px_20px] md:text-xl">
              This led to successfully completing a funding round for our business in what continues to be a difficult
              market for capital investment, which has given confidence to our investors that the business is growing
              and changing and maturing. New investors are coming to us because of this.
            </p>
            <p className="text-muted-foreground font-sans text-lg leading-relaxed ![margin:24px_0px_0px_20px] md:text-xl">
              Personally, I feel that calmness and confidence is important because you can have a million things going
              on in your brain but you need to have that calm and confidence that you portray and feel.
            </p>
            <p className="text-muted-foreground font-sans text-lg leading-relaxed ![margin:24px_0px_0px_20px] md:text-xl">
              I'm in a very different position today than I was 6 months ago in terms of my ability to have that calm
              quiet confidence to deal with anything that is coming at me."
            </p>
            <p className="text-muted-foreground font-sans text-lg md:text-xl mt-6 leading-relaxed">
              <b className="![margin:0px_0px_0px_20px]">James Brennan</b>
              <div>
                <b className="![margin:0px_0px_0px_20px]">Previous CEO ION</b>
              </div>
            </p>
            <p className="text-muted-foreground font-sans text-lg leading-relaxed ![margin:24px_0px_0px_20px] md:text-xl">
              Working with James &amp; ION they secured deals with:
            </p>
            <p className="text-muted-foreground font-sans text-lg leading-relaxed ![margin:24px_0px_0px_20px] md:text-xl">
              - IMG, Cricket Australia, English Premiership League team &amp; Peach Belt Conference
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mt-8 w-full sm:w-auto">
              <Button size="lg" asChild className="rounded-md px-8 h-12 bg-accent-dark text-foreground-accent hover:bg-accent-dark transition-all shadow-medium"></Button>

              <Button size="lg" variant="outline" asChild className="rounded-md px-8 h-12 border-border text-foreground hover:bg-primary/10 transition-all"></Button>
            </div>
          </div>

          {}
          <div className="relative w-full max-w-xl mx-auto lg:max-w-none">
            <Card className="rounded-lg overflow-hidden border border-border/40 shadow-strong bg-card/50 backdrop-blur-sm p-2 !-mt-[110px] max-w-[80%] mx-auto">
              <div className="rounded-md overflow-hidden bg-muted">
                <img src="https://newmavericks.com/wp-content/uploads/2026/04/James-2-copy.jpg" alt="Professional creative agency workflow and strategic digital planning" className="w-full h-auto object-cover transition-transform duration-700 hover:scale-105 block" />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}